import { useEffect, useState } from "react";
import { createFileRoute } from "@tanstack/react-router";
import { seoHead } from "@/config/seoHead";
import { Navigate, useParams } from "@/lib/router-compat";
import Navbar from "@/components/layout/Navbar";
import Footer from "@/components/landing/Footer";
import NotFound from "@/pages/NotFound";
import { fetchProduct, productPath } from "@/lib/products";

/** Äldre URL /produkter/:kategori/:produkt – vidarebefordrar till /:tjanst/:produkt. */
const LegacyProductRedirect = () => {
  const params = useParams();
  const categorySlug = params["kategori"] ?? "";
  const productSlug = params["produkt"] ?? "";
  const [target, setTarget] = useState<string | null | undefined>(undefined);

  useEffect(() => {
    let active = true;
    setTarget(undefined);
    fetchProduct(categorySlug, productSlug)
      .then((res) => {
        if (!active) return;
        setTarget(res ? productPath(res.category.service_slug, res.product.slug) : null);
      })
      .catch(() => active && setTarget(null));
    return () => {
      active = false;
    };
  }, [categorySlug, productSlug]);

  if (target === undefined) {
    return (
      <div className="min-h-dvh bg-background">
        <Navbar />
        <div className="page-container py-20 text-muted-foreground">Laddar produkt…</div>
        <Footer />
      </div>
    );
  }
  if (target === null) return <NotFound />;
  return <Navigate to={target} replace />;
};

export const Route = createFileRoute("/produkter/$kategori/$produkt")({
  head: () => seoHead("/produkter/$kategori/$produkt"),
  component: LegacyProductRedirect,
});
